/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { StudentGradeClassViewModel } from "../types/StudentGradeClassViewModel.ts";

export const studentGradeClassViewModelSchema = z.object({
  classroomDisciplineId: z.optional(
    z.number().int().describe("ID da aula (ClassroomDiscipline)."),
  ),
  classroomDisciplineName: z
    .string()
    .describe(
      "Nome da aula cadastrado no idioma padrão (ClassroomDisciplinesLang.Description). Null quando não há tradução cadastrada. Opcional.",
    )
    .nullish(),
  examName: z
    .string()
    .describe(
      "Título da prova principal (Main = true, Active = true) vinculada à aula. Null quando a aula não possui prova configurada. Opcional.",
    )
    .nullish(),
  grade: z
    .number()
    .describe(
      "Nota obtida na prova, na escala 0-10. Null quando a nota ainda não foi lançada. Opcional.",
    )
    .nullish(),
  weight: z.optional(
    z
      .number()
      .describe(
        "Peso da prova utilizado no cálculo da média ponderada da disciplina.",
      ),
  ),
}) as unknown as ToZod<StudentGradeClassViewModel>;
